<template>
<div class="text-center">
  <v-bottom-sheet v-model="ListBusinessDialog" persistent>
    <v-sheet height="90vh" class="pa-10">
      <v-row class="justify-end align-center pa-5 pt-0" v-if="!persistent">
        <v-btn icon color="grey" @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-row class="justify-center align-center pa-5 pt-0">
        <h2>กรุณาเลือกบัญชีที่ต้องการเข้าใช้งาน</h2>
      </v-row>
      <v-row v-if="progress" class="layout-panels justify-center align-center">
        <v-progress-circular :indeterminate="progress" :width="8" :size="100" color="#083F5E"></v-progress-circular>
      </v-row>
      <div v-else class="layout-panels mt-2" id="myscroll">
        <h4><b>บัญชีทั่วไป (1)</b></h4>
        <v-list flat two-line disabled>
          <v-list-item-group>
            <template>
              <v-list-item>
                <!-- @click="getSharedToken(list_public.one_id)" -->
                <v-list-item-action>
                  <v-avatar size="40">
                    <img v-if="list_public.profile_picture" :src="list_public.profile_picture" alt="" class="img-position">
                    <v-img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" alt="" class="img-position" />
                  </v-avatar>
                </v-list-item-action>
                <v-list-item-content class="pt-0 pb-0">
                  <v-col cols="12">
                    <v-list-item-title v-text="list_public.display_name" class="text-overflow pt-2"></v-list-item-title>
                  </v-col>
                </v-list-item-content>
                <!-- <v-list-item-action>
                  <v-radio-group v-model="select_account">
                    <v-radio
                      :value="select_account === null ? '' : list_public.one_id"
                    ></v-radio>
                  </v-radio-group>
                </v-list-item-action> -->
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
        <v-divider class="ma-5"></v-divider>
        <h4><b>บัญชีองค์กร ({{list_private.length}})</b></h4>
        <v-list flat two-line>
          <v-list-item-group>
            <template v-for="(item, index) in list_private">
              <v-list-item :key="`friend-${item.business_id}`" @click="gotoPage(item.business_id)">
                <v-list-item-action>
                  <v-avatar size="40">
                    <img v-if="item.company_picture" :src="item.company_picture" alt="" class="img-position">
                    <v-icon v-else class="icon-color-grey img-position">fa-solid fa-building</v-icon>
                  </v-avatar>
                </v-list-item-action>
                <v-list-item-content class="pt-0 pb-0">
                  <v-col cols="12">
                    <v-list-item-title v-text="item.company_full_name_th" class="text-overflow pt-2"></v-list-item-title>
                  </v-col>
                </v-list-item-content>
                <!-- <v-list-item-action>
                  <v-radio-group v-model="select_account">
                    <v-radio
                      :value="item.business_id"
                    ></v-radio>
                  </v-radio-group>
                </v-list-item-action> -->
              </v-list-item>
              <v-divider v-if="index < list_private.length - 1" :key="index"></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</div>
</template>
<script>
export default {
  props: {
    ListBusinessData: Object,
    ListBusinessDialog: Boolean,
    persistent: Boolean
  },
  data: () => ({
    publicPath: process.env.VUE_APP_BASE_PATH,
    progress: false,
    sheet: false,
    list_private: [],
    list_public: {},
    select_account: null,
  }),
  watch: {
    ListBusinessDialog() {
      if (this.ListBusinessDialog) {
        // console.log('this.ListBusinessData =>', this.ListBusinessData);
        this.getListBusiness(this.ListBusinessData)
      }
    },
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog', { name: 'ListBusiness', value: false })
    },
    getSharedToken (id) {
      this.progress = true
      var header = { headers: { Authorization: `Bearer ${this.$cookie.get('access_token_one')}` } }
      this.axios.get(process.env.VUE_APP_API_PRIVATE_CHAT + `/v1/account/get-shared-token?encode=false`, header).then((response) => {
        if (response.data.status === 200) {
          window.open(`${process.env.VUE_APP_BASE_PATH}/authen?shared_token=${response.data.data.shared_token}&login_page=true&one_token=${this.$cookie.get('one_token')}`, '_self')
          this.$emit('closeDialog', { name: 'ListBusiness', value: false })
        } else {
          this.$swal({
            text: response.data.message,
            type: 'error',
            confirmButtonColor: '#1B79B1',
            confirmButtonText: this.$t("AnswerQuestion.ok"),
            allowOutsideClick: false,
          })
        }
      }).catch(err => {
        console.log(err.response);
        this.progress = false
        this.$swal({
          text: err.response.data.message,
          type: 'error',
          confirmButtonColor: '#1B79B1',
          confirmButtonText: this.$t("AnswerQuestion.ok"),
          allowOutsideClick: false,
        })
      })
    },
    // getSharedToken (id) {
    //   this.progress = true
    //   var header = { headers: { Authorization: `Bearer ${process.env.VUE_APP_AUTH_SERVICE}` } }
    //   this.axios.post(process.env.VUE_APP_API_PRIVATE_MANAGE + `/v1/service/get-shared-token`, { one_id: id }, header).then((response) => {
    //     if (response.data.status === 200) {
    //       window.open(`${process.env.VUE_APP_BASE_PATH}/authen?shared_token=${response.data.data.shared_token}&login_page=true&one_token=${this.$cookie.get('one_token')}`, '_self')
    //       this.$emit('closeDialog', { name: 'ListBusiness', value: false })
    //     } else {
    //       this.$swal({
    //         text: response.data.message,
    //         type: 'error',
    //         confirmButtonColor: '#1B79B1',
    //         confirmButtonText: 'ตกลง',
    //         allowOutsideClick: false,
    //       })
    //     }
    //   }).catch(err => {
    //     console.log(err.response);
    //     this.progress = false
    //     this.$swal({
    //       text: err.response.data.message,
    //       type: 'error',
    //       confirmButtonColor: '#1B79B1',
    //       confirmButtonText: 'ตกลง',
    //       allowOutsideClick: false,
    //     })
    //   })
    // },
    gotoPage (id) {
      this.progress = true
      window.open(`${process.env.VUE_APP_URL_PRIVATE}/authen?one_token=${this.$cookie.get('one_token')}&business_id=${id}&login_page=true`, '_self')
      this.$emit('closeDialog', { name: 'ListBusiness', value: false })
    },
    getListBusiness(header) {
      this.progress = true
      this.axios.get(process.env.VUE_APP_API_PRIVATE_MANAGE + '/v1/all-account', header).then((response) => {
        if (response.data.status == 200) {
          this.progress = false
          this.list_private = response.data.data.private_account
          this.list_public = response.data.data.public_account
        }
      }).catch((err) => {
        console.log(err.response)
        this.progress = false
        if (err.response.data.status === 401) {
          this.$emit('closeDialog', { name: 'ListBusiness', value: false })
          this.$swal({
            text: this.$t("Settings.messageEditPhone.MsgTokenExpire"),
            type: 'error',
            confirmButtonColor: '#1B79B1',
            confirmButtonText: this.$t("AnswerQuestion.ok"),
            allowOutsideClick: false,
          })
          this.$cookie.delete('login-page')
          this.$cookie.delete('one_token')
          window.open(`${process.env.VUE_APP_URL_PRIVATE}/login`, '_self')
        } else {
          this.$swal({
            text: err.response.data.message,
            type: 'error',
            confirmButtonColor: '#1B79B1',
            confirmButtonText: this.$t("AnswerQuestion.ok"),
            allowOutsideClick: false,
          })
        }

      })
    },
  },
}
</script>
<style scroped>
.layout-panels {
  height: calc(100vh - 260px) !important;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100% !important;
}

.layout-panels::-webkit-scrollbar {
  width: 3px;
}

.layout-panels::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}

.icon-color-white {
  color: white !important;
}
.icon-color-grey {
  color: grey !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 70vw;
}
</style>
